import { Injectable } from '@angular/core';

import { RedactorConfig } from './redactor.types';

@Injectable()
export class RedactorService {
  public readonly defaultActiveButtonsStates: { [key: string]: string } = {
    b: 'bold',
    strong: 'bold',
    i: 'italic',
    u: 'underline',
    em: 'italic',
    del: 'deleted',
    strike: 'deleted',
  };

  public readonly defaultFormatting: string[] = [
    'p',
    'blockquote',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
  ];

  public readonly defaultPasteBlockTags: string[] = [
    'br',
    'p',
    'ul',
    'li',
    'ol',
    'b',
    'i',
    'u',
    'strong',
    'a',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'blockquote',
  ];

  public commonConfig: RedactorConfig = {
    activeButtons: this.defaultActiveButtonsStates,
    rtPlaceholdersExcludeParentSelector: '.recruitee-quote',
    rtLinksExcludeParentSelector: '.recruitee-quote',
    toolbarFixed: false,
    linkSize: 2083,
    linkNewTab: true,
    pasteBlockTags: this.defaultPasteBlockTags,
    lang: 'en',
    imageFigure: false,
    imageResizable: true,
    shortcutsAdd: {
      shift: { api: 'module.list.indent' },
      'shift+tab': { api: 'module.list.outdent' },
    },
  };

  public simpleConfig: RedactorConfig = {
    ...this.commonConfig,
    buttons: ['bold', 'italic', 'underline', 'link', 'undo', 'redo'],
    plugins: ['rt-link-toggle'],
  };

  public defaultConfig: RedactorConfig = {
    ...this.commonConfig,
    buttons: ['bold', 'italic', 'underline', 'ol', 'ul', 'link', 'undo', 'redo'],
    plugins: [
      'alignment',
      'fontcolor',
      'fontsize',
      'rt-quote',
      'rt-placeholder',
      'rt-link',
      'rt-link-toggle',
    ],
  };

  public emailConfig: RedactorConfig = {
    ...this.commonConfig,
    buttons: ['bold', 'italic', 'underline', 'ol', 'ul', 'link', 'undo', 'redo', 'image', 'html'],
    plugins: [
      'alignment',
      'fontcolor',
      'fontsize',
      'rt-quote',
      'rt-placeholder',
      'rt-link',
      'rt-upload',
      'rt-font-family',
      'rt-link-toggle',
    ],
  };

  public richConfig: RedactorConfig = {
    ...this.commonConfig,
    buttonsAdd: ['file', 'html'],
    buttons: ['bold', 'italic', 'underline', 'format', 'ol', 'ul', 'link', 'image', 'undo', 'redo'],
    plugins: [
      'rt-quote',
      'rt-placeholder',
      'rt-link',
      'rt-upload',
      'rt-alignment-buttons',
      'rt-link-toggle',
      'video',
      'fontsize',
      'fontcolor',
      'file',
      'alignment',
      'fullscreen',
    ],
    toolbarFixed: false,
    source: true,
    autoparseVideo: true,
    formatting: this.defaultFormatting,
    toolbarContext: true,
    imagePosition: true,
  };
}
